import React, { useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowLeft from '@wix/da-ds/pkg/Icons/ArrowLeft';
import { DuperbrowseItem } from '../redux/types';
import { getBasicBiDataForDuperItem } from '../redux/helpers';
import { yieldToMain } from '@wix/da-hooks/pkg/yieldToMain';
import { BackToClickBiEvent, BiData } from '@wix/da-bi/pkg/events';
import s from './BackToStreamButton.scss';

export interface Props {
  currentItem?: DuperbrowseItem;
  parent?: {
    url: string;
    title?: string;
    typeId?: number;
    itemId?: number;
  };
  className?: string;
  exitDuperbrowse: () => void;
}

const BackToStreamButton: React.FC<Props> = ({
  className,
  exitDuperbrowse,
  parent,
  currentItem,
}) => {
  const { t } = useTranslation();
  const doExit = useCallback(() => {
    yieldToMain(() => {
      exitDuperbrowse();
    });
  }, [exitDuperbrowse]);

  if (!parent || !currentItem) {
    return null;
  }
  return (
    <TextButton
      icon={ArrowLeft}
      variant="main"
      size="small"
      biData={BiData<BackToClickBiEvent>({
        evid: 304,
        ...getBasicBiDataForDuperItem(currentItem),
        link_url: parent.url,
        next_itemid: parent.itemId,
        next_typeid: parent.typeId,
      })}
      className={classnames(s['duperexit'], className)}
      onClick={doExit}
      noHorizontalPaddings={false}
    >
      {parent.title || t('deviation.duperbrowse.back')}
    </TextButton>
  );
};

BackToStreamButton.displayName = 'BackToStreamButton';

export default BackToStreamButton;
